module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0091.png.d2682389.jpg";